import { gate } from 'hub-http/gates';
export const GATES = {
  REQUEST_NOTE_RICH_TEXT: gate('ProductApprovals::RequestNoteRichText'),
  USER_SENT_REMINDER_NOTIFICATION: gate('ProductApprovals:UserSentReminderNotification'),
  GO_TO_MARKETING_STUDIO: gate('GoToMarketingStudio'),
  CHANGES_REQUESTED: gate('ProductApprovals:ChangesRequested'),
  // Also drives reading the new "generic" (V2) unified events in the sidepanel
  // instead of the legacy per-type (V1) events.
  AGENT_APPROVER: gate('ProductApprovals::AgentApprover'),
  ORDERED_APPROVAL_STEPS: gate('ProductApprovals::OrderedApprovalSteps')
};